<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :isSingle="isSingle"
      @delRow="delRow"
    >
    </page-main>
  </div>
</template>

<script>
import PageMain from './main'
export default {
  components: {
    PageMain,
  },
  props: {
    tableData: { type: Array, default: () => [] },
    isSingle: { type: Boolean, default: false },
  },
  data() {
    return {
      usePage: false,
    }
  },
  methods: {
    delRow(rowId) {
      this.$emit('delRow', rowId)
    },
  },
}
</script>
